import { format, parseISO } from "date-fns";
import type { Granularity } from "~/components/charts/granularity";

const axisFormat: Record<Granularity, string> = {
  daily: "d MMM",
  weekly: "d MMM",
  monthly: "MMM yyyy",
};

export const formatBucketAxisLabel = (
  isoDate: string,
  granularity: Granularity,
): string => format(parseISO(isoDate), axisFormat[granularity]);

export const formatBucketDate = (isoDate: string): string =>
  format(parseISO(isoDate), "d MMM yyyy");
